import { Menu } from './menu';
import { ListRoleAndDivision } from './division';

export class BluePrintUser {
  profile_picture: string;
  username: string;
  fullname: string;
  email: string;
  phone: string;
  company_name: string;
  account_status: string;
}

export class User extends BluePrintUser {
  _id: string;
  current_role: ListRoleAndDivision;
  another_role: Array<ListRoleAndDivision>;
  selected_role_div: number;
  agreeterms_at: any;
  last_login: Date;
  has_menu: Array<Menu>;
  ability: UserAbility;
  tickets: {
    open: string;
    solved: string;
    closed: string;
  };
  account_category: Array<Category>;
}

export class UserWithActicity extends User {
  activities: Activity;
}

export class Activity {
  message: string;
  highlight: string;
  date: Date;
}

export class Administrator extends BluePrintUser {
  _id: string;
  current_role: ListRoleAndDivision;
  another_role: Array<ListRoleAndDivision>;
  selected_role_div: number;
  agreeterms_at: any;
  last_login: Date;
  user_menu: Menu;
  ability: UserAbility;
  tickets: {
    open: string;
    solved: string;
    closed: string;
  };
  account_category: AdminCategory;
}

export class Notification {
  length: number;
  notifications: Array<NotificationData>;
}

export class NotificationData {
  user_id: string;
  message: string;
  is_seen: boolean;
  user_name: string;
  user_profilepic: string;
  date: Date;
}

export class UserAbility {
  is_client: boolean;
  can_label: boolean;
  can_distribute: boolean;
  can_take: boolean;
  can_assign: boolean;
}

export class Category {
  division: string;
  roles: string;
  created_at: Date;
}

export class AdminCategory extends Category {
  division_name: string;
  role_name: string;
}

export class FirstTimeUser {
  token: string;
  isFirstTime: boolean;
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/_shared/models/user.ts